import base from '../base/base';
import header from '../base/header';
import GTAds from '../../components/ads/GTAds';

//temporary hotfix for gametrax
var isGT = location.pathname.match('/gametrax');
isGT && new GTAds(base.ads);



// WEBPACK FOOTER //
// ./assets/layouts/big-board/big-board.js